export default "__VITE_ASSET__BFMw4l$h__"